<script setup lang="ts">
import { AppButton } from '../button';

const props = withDefaults(
  defineProps<{
    visible: boolean;
    saving: boolean;
    message?: string;
  }>(),
  {
    message: 'Есть несохранённые изменения',
  },
);

defineEmits<{
  save: [];
  reset: [];
}>();
</script>

<template>
  <Transition
    enter-active-class="transition-[opacity,transform] duration-200 ease-out"
    enter-from-class="translate-y-3 opacity-0"
    leave-active-class="transition-[opacity,transform] duration-150 ease-in"
    leave-to-class="translate-y-2 opacity-0"
  >
    <div
      v-if="props.visible"
      class="sticky bottom-0 z-10 mx-1 flex flex-col gap-3 rounded-xl border border-(--base-border-color) bg-(--base-container-bg)/95 px-4 pt-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-lg backdrop-blur-md md:flex-row md:items-center md:justify-between md:px-6 md:pt-6 md:pb-[max(1.5rem,env(safe-area-inset-bottom))]"
    >
      <p class="text-sm font-medium text-pretty text-(--base-text-color)">
        {{ props.message }}
      </p>
      <div class="flex flex-col gap-2 sm:flex-row sm:justify-end">
        <AppButton
          class="min-h-11 w-full sm:w-auto"
          outline
          :disabled="props.saving"
          @click="$emit('reset')"
        >
          Отменить
        </AppButton>
        <AppButton
          class="min-h-11 w-full sm:w-auto"
          :loading="props.saving"
          @click="$emit('save')"
        >
          Сохранить
        </AppButton>
      </div>
    </div>
  </Transition>
</template>
